module.exports = new __parcel__URL__("marker-shadow.8f26ed1f.png").toString();